import { useCallback, useEffect, useState } from "react";

import { fetchArtifactsForViewer, ViewerArtifacts } from "../../../data/queries/viewer";
import { useAuth } from "../../auth/AuthContext";

export const useArtifactDetails = (interactionId: string | null) => {
  const { tenantId } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<ViewerArtifacts | null>(null);

  const fetchData = useCallback(async () => {
    if (!interactionId) {
      setError("No interaction ID provided");
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const result = await fetchArtifactsForViewer({ tenantId: tenantId!, interactionId });

      if (result.error) {
        setError(result.error.message);
        return;
      }

      if (!result.data) {
        setError("No artifacts found for this interaction");
        return;
      }

      setData(result.data);
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setIsLoading(false);
    }
  }, [interactionId, tenantId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    data,
    isLoading,
    error,
    fetchData
  };
};

export default useArtifactDetails;
